<template lang="html">
    <gcmcn-layout
        title="GENERAL"
        custom-class="general-view"
    >
        <ns-loader
            :to-load="toLoad"
            @dataFetched="onDataFetched"
            :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
        >
            <loading-template slot="loader"></loading-template >
            <div slot="content">
                <el-row :gutter="40" class="gcmcn-separator">
                    <el-col
                        :span="eventsSpanWidth"
                        :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                        style="overflow: none; transition: all ease-in-out .7s;"
                    >
                        <event-list
                            ref="events_list"
                            :events="events"
                            :universes="universes"
                            :focused="focus_events_list"
                            @changeSelectedEvent="onEventSelected"
                            @removeFocus="removeFocus"
                            @setFocus="setFocus"
                        ></event-list>
                    </el-col>
                    <el-col
                        :span="feedsSpanWidth"
                        :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                        style="overflow: none; transition: all ease-in-out .7s;"
                    >
                        <feed-list
                            v-if="selectedEvent !== null"
                            ref="feeds_list"
                            :key="selectedEvent.uid"
                            :event="selectedEvent"
                            :universes="universes"
                            :selected-feed="selectedFeed"
                            :focused="focus_feeds_list"
                            @on-feed-selected="onFeedSelected"
                            @removeFocus="removeFocus"
                            @setFocus="setFocus"
                        ></feed-list>
                    </el-col>
                    <el-col
                        :span="takersSpanWidth"
                        :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                        style="overflow: none; transition: all ease-in-out .7s;"
                    >
                        <taker-list
                            v-if="selectedFeed !== null"
                            ref="takers_list"
                            :key="selectedFeed.uid"
                            :feed="selectedFeed"
                            :focused="focus_takers_list"
                            @removeFocus="removeFocus"
                            @setFocus="setFocus"
                        ></taker-list>
                    </el-col>
                </el-row>
            </div>
        </ns-loader>
    </gcmcn-layout>
</template>

<script>
import EventList from './event-list.vue';
import FeedList from './feed-list.vue';
import TakerList from './taker-list.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';

import LoadingTemplate from '../../partials/ns-loader-template.vue';
export default {
    components: {
        GcmcnLayout,
        EventList,
        FeedList,
        TakerList,
        NsLoader,
        LoadingTemplate,
    },
    data () {
        return {
            selectedEvent: null,
            selectedFeed: null,
            toLoad: [
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
                {
                    name: 'universes',
                    model: 'universes',
                },
            ],
            events: [],
            universes: [],
            focus_events_list: true,
            focus_feeds_list: false,
            focus_takers_list: false,
        };
    },
    computed: {
        eventsSpanWidth() {
            if (this.$store.getters.windowWidth > 1024) {
                return 7;
            }
            if (this.focus_events_list === true) {
                return 16;
            } else {
                return 4;
            }
        },
        feedsSpanWidth() {
            if (this.$store.getters.windowWidth > 1024) {
                return 10;
            }
            if (this.focus_feeds_list === true) {
                return 16;
            } else {
                return 4;
            }
        },
        takersSpanWidth() {
            if (this.$store.getters.windowWidth > 1024) {
                return 7;
            }
            if (this.focus_takers_list === true) {
                return 16;
            } else {
                return 4;
            }
        },
    },
    methods: {
        removeFocus(refs) {
            refs.forEach(ref => {
                this.$set(this, `focus_${ref}`, false);
            });
        },
        setFocus(ref) {
            this[`focus_${ref}`] = true;
        },
        onEventSelected (event){
            this.$set(this, 'selectedFeed', null);
            this.$set(this, 'selectedEvent', event);
            this.removeFocus(['events_list']);
            this.setFocus('feeds_list');
        },
        onFeedSelected (feed){
            this.$set(this, 'selectedFeed', feed);
            this.removeFocus(['feeds_list']);
            this.setFocus('takers_list');
        },
        onDataFetched (res){
            this.$set(this, 'events', res.events);
            this.$set(this, 'universes', res.universes);
        },
    }
};
</script>

<style lang="scss">
.general-view{
    .gcmcn-filter-container{
        margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/index.vue